<template>
    <div>
         <v-row>
            <v-col>
                <h2 class="text-left mx-4">Edit Timetable</h2>
            </v-col>
        </v-row>
        <v-row class="mx-2">
            <v-col cols="12" md="3" sm="6">
                <v-autocomplete
                label="Classroom"
                :items="classroomItems"
                dense
                filled
                rounded
                return-object
                solo
                hide-details
                v-model="currentClassroom"
                item-text="sections"
                id="edit-timetable-autocomplete"
                @change="getFaculty();handleTourAfterClick();"
                >
                </v-autocomplete>
            </v-col>
            <v-spacer> </v-spacer>
            <v-col cols="12" md="3" sm="6" v-if="currentClassroom">
                <v-btn
                  color="primary"
                  class="mx-3"
                  id='view-timetable'
                  @click="showConfirmation = true"
                >View Timetable </v-btn>
            </v-col>
        </v-row>
        <v-row class="my-2 mx-2" v-if="currentClassroom">
            <v-col>
                <v-tabs center-active fixed-tabs show-arrows v-model="tab">
                    <v-tab>Monday</v-tab>
                    <v-tab>Tuesday</v-tab>
                    <v-tab>Wednesday</v-tab>
                    <v-tab>Thursday</v-tab>
                    <v-tab>Friday</v-tab>
                    <v-tab>Saturday</v-tab>
                    <v-tab>Sunday</v-tab>
                    <v-tab-item>
                        <TimetableTabItems
                            :tab="tab"
                            :facultyItems="facultyItems"
                            :slotItems="slotItems"
                            :subjectItems="subjectItems"
                            :classId="currentClassroom.id"
                         />
                    </v-tab-item>
                    <v-tab-item>
                        <TimetableTabItems
                            :classId="currentClassroom.id"
                            :tab="tab"
                            :facultyItems="facultyItems"
                            :slotItems="slotItems"
                            :subjectItems="subjectItems"
                         />
                    </v-tab-item>
                    <v-tab-item>
                        <TimetableTabItems
                            :classId="currentClassroom.id"
                            :tab="tab"
                            :facultyItems="facultyItems"
                            :slotItems="slotItems"
                            :subjectItems="subjectItems"
                         />
                    </v-tab-item>
                    <v-tab-item>
                        <TimetableTabItems
                            :classId="currentClassroom.id"
                            :tab="tab"
                            :facultyItems="facultyItems"
                            :slotItems="slotItems"
                            :subjectItems="subjectItems"
                         />
                    </v-tab-item>
                    <v-tab-item>   
                        <TimetableTabItems
                            :classId="currentClassroom.id"
                            :tab="tab"
                            :facultyItems="facultyItems"
                            :slotItems="slotItems"
                            :subjectItems="subjectItems"
                         />
                    </v-tab-item>
                    <v-tab-item>
                        <TimetableTabItems
                            :classId="currentClassroom.id"
                            :tab="tab"
                            :facultyItems="facultyItems"
                            :slotItems="slotItems"
                            :subjectItems="subjectItems"
                         />
                    </v-tab-item>
                    <v-tab-item>
                        <TimetableTabItems
                            :classId="currentClassroom.id"
                            :tab="tab"
                            :facultyItems="facultyItems"
                            :slotItems="slotItems"
                            :subjectItems="subjectItems"
                         />
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar.visible" timeout="2000">
            {{ snackbar.text }}
            <template>
                <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
            </template>
        </v-snackbar>
        <ConfirmationDialog
            title="Are you sure you want to leave this page?"
            description="All your changes will be lost."
            successText="Proceed"
            failureText="Cancel"
            @failureCallback="showConfirmation = false"
            @successCallback="proceedConfirmation"
            :visible="showConfirmation"
        >
        </ConfirmationDialog>
    </div>

</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import moment from "moment";
import api from "@api/index";
import endpoints from "@api/repository";
// import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog.vue";
// import Helper from "@utils/misc";
import TimetableTabItems from "@components/timetable/TimetableTabItems";
import TourHelper from "@utils/tour_helper";
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog.vue";


export default {
    name: 'CreateEditTimetable',
    props:['room_id'],
    components: {
        TimetableTabItems,
        ConfirmationDialog
    },

  data() {
        return{
            classroomItems:[],
            showConfirmation: false,
            currentClassroom:null,
            tab:0,
            facultyItems:[],
            subjectItems:[],
            slotItems:[],
            snackbar: {
                visible: false,
                text: ""
            },
        }
    },

    computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors
      };
     },
    },
    methods: {
    ...mapActions(["setLoading", "setActiveSessionData"]),
    proceedConfirmation() {
        this.showConfirmation = false;
        this.$router.push(
        {
            name: 'ClassroomTimetable',
            params: { roomId: this.currentClassroom.id },
        });
    },
    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Edit Timetable", description: "View and edit current classroom's timetable.", videoLink: "https://youtube.com"});
        steps.push({id: '2', description: "Select a classroom for further instructions", position:'top' ,el: '#edit-timetable-autocomplete'});
        steps.push({id: '3', description: "Navigate and view current classroom timetable after editing is done." ,el: '#view-timetable'});
        TourHelper.startTour(this, "edit__timetable", steps);
    },

    handleTourAfterClick() {
        var steps = [];
        steps.push({id: '1', description: "Navigate and view current classroom timetable after editing is done." ,el: '#view-timetable'});
        TourHelper.startTour(this, "edit__timetable__after__click", steps);
    },

        addTabItems(){
            var tabObject = {}
            if(this.tab==0){
                    this.mondayItems.push(tabObject);
             }
            else if(this.tab==1){
                this.tuesdayItems.push(tabObject);
            }
            else if(this.tab==2){
                this.wednesdayItems.push(tabObject);
            }
            else if(this.tab==3){
                this.thursdayItems.push(tabObject);
            }
            else if(this.tab==4){
                this.fridayItems.push(tabObject);
            }
            else if(this.tab==5){
                this.saturdayItems.push(tabObject);
            }
            else if(this.tab==6){
                this.sundayItems.push(tabObject);
            }
                
        },

        // To get class names for dropdown
        async getClassroomItems() {
        var url = endpoints.getAllRooms;
        var response;
        response = await api.handleApi({
            apiEssentials: this.essentials,
            url: url,
            responseVar: response
        });

        if (response) {
            this.classroomItems = response;

            if(this.room_id){
                this.currentClassroom = this.classroomItems.find(x => x.id == this.room_id)
            }
        }
    },


        // To get subject names for dropdown
        async getSubjectItems() {
        if(this.currentClassroom.id){
            var url = endpoints.getClassRoomSubjects + `${this.currentClassroom.id}/`;
        }
                var response;
        response = await api.handleApi({
            apiEssentials: this.essentials,
            url: url,
            responseVar: response
        });
        if(response){
            this.subjectItems = response
        }
    },

        async getFaculty(){
            var url = endpoints.getAllStaff + `?associated_classroom=${this.currentClassroom.id}&all=true`;
            var response;
            response = await api.handleApi({
                apiEssentials: this.essentials,
                url: url,
                responseVar: response
            });
            if(response){
                this.facultyItems = response
                this.getSubjectItems();
            }
        },


        async getTimeSlots(){
            var url = endpoints.getTimeSlots;
            var response;
            response = await api.handleApi({
                apiEssentials: this.essentials,
                url: url,
                responseVar: response
            });  

            if(response){
                this.slotItems = response;
            }
        },

        async handleApiErrors(err) {
        this.setLoading(false);
        if (err.response) {
            console.log(err.response);
        } 
        else {
            this.snackbar.text = "Unknown error occurred";
            this.snackbar.visible = true;
        }
        }
    },

    created(){
        this.getTimeSlots()
        // if(this.currentClassroom)
        if(this.room_id){
            this.currentClassroom = {
                id: this.room_id,
            }
            this.getFaculty()
            // this.handleTourAfterClick()
        }
        this.getClassroomItems();
        this.handleTour();
        // this.getAllTimetableItems();
    },

    

}
</script>